import { all, fork } from 'redux-saga/effects';

import listenCancel from './listenCancel';
import listenConfirm from './listenConfirm';
import listenReject from './listenReject';

export default function* bookingCardSaga() {
  yield all([fork(listenConfirm), fork(listenCancel), fork(listenReject)]);
}
